<template>
  <section></section>
</template>
<script>
import load from './dynamicLoadScript'

const tinymceCDN = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=53d8e0c0-50f3-11ec-b574-b9927c5d8b10&autoShow=true&language=ZHCN'

export default {
  name: 'CustomerService',
  data() {
    return {}
  },
  mounted() {
    load(tinymceCDN, (err) => {
        if (err) {
            console.log(err.message)
            return
        }
    })
  }
}
</script>